import {ROUTES} from '@/utils/constants/routesConstants'
import {useState, useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

export const useTaxesAndEditHook = ({formData, setFormData}) => {
  // Local state for UI handling
  const [localTaxes, setLocalTaxes] = useState(formData.taxes || [])
  const [localSaleUoms, setLocalSaleUoms] = useState(formData.saleUoms || [])
  const [isCancel, setIsCancel] = useState(false)
  const navigate = useNavigate()
  const {id} = useParams()

  // Sync local state when formData changes from parent
  useEffect(() => {
    if (formData?.taxes && JSON.stringify(localTaxes) !== JSON.stringify(formData.taxes)) {
      setLocalTaxes(formData.taxes || [])
    }
    if (formData?.saleUoms && JSON.stringify(localSaleUoms) !== JSON.stringify(formData.saleUoms)) {
      setLocalSaleUoms(formData.saleUoms || [])
    }
  }, [formData, localTaxes, localSaleUoms])

  const handleTaxInputChange = (index, field, value) => {
    // Update local taxes state
    setLocalTaxes(prevTaxes => {
      const updatedTaxes = [...prevTaxes]
      if (updatedTaxes[index]) {
        updatedTaxes[index] = {
          ...updatedTaxes[index],
          [field]: value
        }
      }
      
      // Update parent state immediately to ensure persistence across tabs
      setFormData({
        ...formData,
        taxes: updatedTaxes
      })
      
      return updatedTaxes
    })
  }

  const handleSalesUomsInputChange = (index, field, value) => {
    // Update local sale UOMs state
    setLocalSaleUoms(prevUoms => {
      const updatedUoms = [...prevUoms]
      if (updatedUoms[index]) {
        updatedUoms[index] = {
          ...updatedUoms[index],
          [field]: value
        }
      }
      
      // Update parent state immediately to ensure persistence across tabs
      setFormData({
        ...formData,
        saleUoms: updatedUoms
      })
      
      return updatedUoms
    })
  }

  const saveChanges = () => {
    // Only update the parent formData when explicitly saving
    setFormData({
      ...formData,
      taxes: localTaxes,
      saleUoms: localSaleUoms
    })
  }

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }

  const onClickPrimaryButton = () => {
    navigate(`${ROUTES.PRODUCT_REVIEW.replace(':id', id)}`, { state: { selectedTabNumb: 4 } }) // Replace :id with the actual productId
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  return {
    taxFields: localTaxes,
    saleUomsFields: localSaleUoms,
    handleTaxInputChange,
    handleSalesUomsInputChange,
    handleCancel,
    isCancel,
    onClickPrimaryButton,
    onClickSecondaryButton,
    saveChanges
  }
}
